import ProblemDetailsError from './ProblemDetailsError';

/**
 * True when an error represents an HTTP 401 from the API. Prefer this over
 * string-matching the "Unauthorized." title so callers (e.g. the QueryClient
 * retry predicate) can reliably skip retrying auth failures.
 */
export default function isAuthError(err: unknown): boolean {
    return (
        err instanceof ProblemDetailsError && err.problemDetails.status === 401
    );
}
